export interface FacilityRequest {
    amount: number;
    status: number;
    provider: string;
    contractDate: any;
    statusName: string;
    createDate: string;
    cardNumber: string;
    description: string;
    isEditable: boolean;
    hasLanding: boolean;
    facilityName: string;
    isDeletable: boolean;
    contractFile: string;
    creditLayerId: number;
    landingMessage: string;
    organizationId: number;
    contractNumber: string;
    installmentCount: number;
    organizationName: string;
    hasContractFile: boolean;
    isPayInstallment: boolean;
    facilityRequestId: number;
    collateralDescription: string;
    isEditableRejectOnEducationAndCareerInfo: boolean;
};

export interface FacilityRequestHistory {
    amount: number;
    provider: string;
    statusName: string;
    createDate: string;
    description: string;
    installmentCount: number;
    facilityRequestId: number;
};

export interface FacilityRequestFlow {
    icon: string;
    title: string;
    success?: any;
    status: number;
    stepUrl: string;
    isActive: boolean;
    actionName: string;
    hasAction: boolean;
    isRejected: boolean;
    description: string;
};

export enum CREDIT_LAYER_ENUM {
    JETVAM = 1,
    AIR_CONDITIONER = 4,
};

export interface BankInquiry {
    bankAccountInquiry: string;
};

export interface FacilityUserInfo {
    city: string;
    floor: string;
    plaque: string;
    gender: string;
    address: string;
    province: string;
    lastName: string;
    firstName: string;
    userCardId: number;
    fatherName: string;
    postalCode: string;
    phoneNumber: string;
    nationalCode: string;
    userAddressId: number;
    userCardNumber: string;
    birthDateShamsi: string;
    firstClassFamillyLastName: string;
    firstClassFamillyFirstName: string;
    firstClassFamillyMobileNumber: string;
    firstClassFamillyRelationship: string;
    firstClassFamillyNationalCode: string;
};

export interface DocumentTypeBasedOnCareer {
    id: number;
    name: string;
    description: string;
};

export interface JetClubPlanList {
    name: string;
    variants: any;
    amount: number;
};